import { render } from "./PixKeyClaimRequestInProgress.vue?vue&type=template&id=954f3dac"
import script from "./PixKeyClaimRequestInProgress.vue?vue&type=script&lang=js"
export * from "./PixKeyClaimRequestInProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__